export const utf8ToBase64 = str => window.btoa(unescape(encodeURIComponent(str)));

export const base64ToUtf8 = str => decodeURIComponent(escape(window.atob(str)));
